import {setNavOpen} from "./commit_helpers";

export function toggleNav(sm) {
    setNavOpen(sm, !sm.state['navOpen'])
}
